document.addEventListener('DOMContentLoaded', () => {
  const articleContent = document.querySelector('.template-article .article__content');
  const toc = document.querySelector('.template-article .article-toc');

  if (!articleContent || !toc) return;

  articleContent.querySelectorAll('table').forEach((table) => {
    if (table.parentElement?.classList.contains('article-table-scroll')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'article-table-scroll';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Scrollable table');
    table.before(wrapper);
    wrapper.append(table);
  });

  const headings = [...articleContent.querySelectorAll('h2')];
  if (headings.length < 2) return;

  const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
  const list = document.createElement('ol');
  list.className = 'article-toc__list';

  headings.forEach((heading, index) => {
    if (!heading.id) {
      let id = `article-heading-${index + 1}`;
      let suffix = 2;

      while (usedIds.has(id)) {
        id = `article-heading-${index + 1}-${suffix}`;
        suffix += 1;
      }

      heading.id = id;
      usedIds.add(id);
    }

    const item = document.createElement('li');
    const link = document.createElement('a');
    item.className = 'article-toc__item';
    link.className = 'article-toc__link';
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', (event) => {
      event.preventDefault();
      heading.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      window.history.pushState(null, '', link.href);
    });
    item.append(link);
    list.append(item);
  });

  toc.append(list);
  toc.hidden = false;

  if ('IntersectionObserver' in window) {
    const linksById = new Map(
      [...list.querySelectorAll('.article-toc__link')].map((link) => [
        decodeURIComponent(link.hash.slice(1)),
        link
      ])
    );

    const setCurrentHeading = (id) => {
      linksById.forEach((link, headingId) => {
        if (headingId === id) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const observer = new IntersectionObserver((entries) => {
      const visibleHeading = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

      if (visibleHeading) setCurrentHeading(visibleHeading.target.id);
    }, {
      rootMargin: '-20% 0px -65% 0px',
      threshold: 0
    });

    headings.forEach((heading) => observer.observe(heading));
  }
});
